<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Payment Methods</h1>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create Payment Method</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
          v-bind="pagingOptions"
          mobile-break-point="1264"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <payment-method-edit-dialog
      :show="showDialog"
      v-model="editedItem"
      @close="showDialog = false"
      @input="onSave"
    />
    <v-row v-if="debug">
      <v-col>
        <pre>{{ paymentMethods }}</pre>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import gql from "graphql-tag";
import PaymentMethodEditDialog from "./PaymentMethodEditDialog.vue";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
const LIST_QUERY = gql`
  query paymentMethods {
    paymentMethods {
      totalCount
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createPaymentMethod($input: PaymentMethodInput!) {
    createPaymentMethod(input: $input) {
      id
      name
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updatePaymentMethod($input: PaymentMethodInput!) {
    updatePaymentMethod(input: $input) {
      id
      name
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deletePaymentMethod($input: PaymentMethodInput!) {
    deletePaymentMethod(input: $input) {
      id
      name
    }
  }
`;
export default {
  components: { PaymentMethodEditDialog, DefaultListActions },
  name: "payment-methods",
  mixins: [ListMixin],

  data() {
    return {
      debug: false,
      showDialog: false,
      editedItem: null,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },

        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.paymentMethods && this.paymentMethods.edges
        ? this.paymentMethods.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedItem = {
        id: "",
        name: "",
      };
      this.showDialog = true;
    },
    onDeleteItem(item) {},
    onEditItem(item) {
      this.editedItem = item;
      this.showDialog = true;
    },
    onSave(payload) {
      this.showDialog = false;
      this.$apollo
        .mutate({
          mutation: payload.id ? UPDATE_MUTATION : CREATE_MUTATION,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Payment Method Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Payment Method Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    paymentMethods: {
      query: LIST_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.searchParams,
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/payment-methods/PaymentMethods.vue